const companyDetaills = () => {
  const companyDetails = {
    CompanyName: process.env.REACT_APP_CompanyName,
    Website: process.env.REACT_APP_Website,
    Support: process.env.REACT_APP_Support,
    ServiceName: process.env.REACT_APP_ServiceName,
    ServiceNameFullName: process.env.REACT_APP_ServiceNameFullName,
  };
  return companyDetails;
};

export const AddAzureAccountText =
  "<p>To add an Azure account, " +
  companyDetaills().ServiceName +
  " needs your Azure Account Name, Tenant (Active Directory) ID, Azure Application (client) ID and the Azure Application (client) Secret.</p>";
export const AddAzureAccountText1 =
  "<p> The credentials are only used to read " +
  companyDetaills().ServiceName +
  " pertinent information and are not retained after the requisite information is obtained.</p>";
export const ChoosePlanText =
  "<div><p>Would you like to know whether your VMs are oversized, undersized or already rightsized, with respect to CPU, Memory, Disks, and Network, resulting in higher cost or poor performance?</p></div><div><p>Would you like to know which VMs to resize, how so, with what benefit in terms of cost and performance, and for how long will the resizing last given trends?</p></div><div style='padding: 0px 60px;'><p> Would you like to ensure that VMs resized will deliver the expected performance at the stated cost?</p></div>";
export const CoosePlanSubDescpription =
  companyDetaills().CompanyName +
  " " +
  companyDetaills().ServiceName +
  " will answer all these questions so that you can get optimal performance at optimal cost.";
export const FreeTrialText =
  "<p>The Free Trial option of " +
  companyDetaills().CompanyName +
  " " +
  companyDetaills().ServiceName +
  " helps you understand how " +
  companyDetaills().ServiceName +
  " works using a single reasonably sized VM of your choice.</p><div><p>You provide the cloud account information which " +
  companyDetaills().ServiceName +
  " will use to list VMs that you can choose from for assessment and recommendation. " +
  companyDetaills().ServiceName +
  "'s assessment and recommendation are based on machine-learning methods applied to the VM's performance metrics in the context of VM's sizing.  The assessment indicates whether the VM resources are oversized, rightsized or undersized resulting in excess costs, reasonable costs, or reduced costs and whether the VM resources are in a healthy or unhealthy performance state.</p></div><p>" +
  companyDetaills().ServiceName +
  " will generate the results of the assessment and its recommendations for the VM under three different modes -- economical, balanced and healthy. You can explore each of these results in detail.</p>";
export const UploadDataText = "Add Upload file discription";
export const VmlistText = "Add Vmlist Instruction discription";
export const SerraLabsModalHeader =
  companyDetaills().CompanyName + " " + companyDetaills().ServiceName;
export const SerraLabsHeader =
  companyDetaills().CompanyName + " " + companyDetaills().ServiceName;
export const SessionExpiredText =
  "User has been logged out because of session inactivity.";
export const CacheErrorText = "Server is not reachable, please login and retry";
export const ServerError =
  "Something went wrong,please contact " + companyDetaills().Support;
export const CostHigh = "Good";
export const CostLow = "Fair";
export const CostOK = "Poor";
export const CostHighColor = "#007E60";
export const CostTooHighColor = "#880C25";
export const CostLowColor = "#FFB939";
export const CostTooLowColor = "#0c171c";
export const CostOKColor = "#C30000";
export const HealthGood = "Normal";
export const HealthPoor = "Abnormal";
export const HealthFair = "Borderline";
export const HealthGoodColor = "#007E60";
export const HealthPoorColor = "#C30000";
export const HealthFairColor = "#FFB939";
export const Shrinking = "Shrinking";
export const Growing = "Growing";
export const UtilHigh = "High";
export const UtilLow = "Low";
export const UtilMedium = "Medium";
export const CostTooHigh = "Too High";
export const CostTooLow = "Too Low";


export const AssessmentFailNoMetricData = "Not enough metric data on VM ";
export const AssessmentFail =
  "Analysis failed because of some internal error for VM ";
export const PPUPREQUESTCOFIRMATIONTEXT =
  "Your request has been sent successfully. You will get confirmation email from " +
  companyDetaills().Support +
  " soon...";
export const VMRersourceChangedFLagInfoTextAnalyzed =
  "The analysis and recommendation of this VM is no longer current as the VM sizing has changed.";
export const ASPRersourceChangedFLagInfoTextAnalyzed =
  "The analysis and recommendation of this ASP is no longer current as the ASP sizing has changed.";
export const VMRersourceChangedFLagInfoTextValidated =
  "The analysis, recommendation and validation of this VM is no longer current as the VM sizing has changed.";
export const VMResourceChngedFlagInfoTextSummaryAnalyzed =
  "VM sizing has changed post analysis and recommendation, reset and analyze to make analysis and recommendation current. ";
export const ASPResourceChngedFlagInfoTextSummaryAnalyzed =
  "ASP sizing has changed post analysis and recommendation, reset and analyze to make analysis and recommendation current. ";
export const VMResourceChngedFlagInfoTextSummaryValidated =
  "VM and related sizing has changed post analysis, recommendation, and validation; reset and analyze to make analysis and recommendation current. ";
export const VMResourceCHangeFlagInfoTextSummaryOptimizing =
  "VM resizing per optimization recommendations has been initiated;  analysis, recommendation and validation above are based on previous VM and related size. ";
export const VMResourceCHangeFlagInfoTextSummaryOptimized =
  "VM resizing per optimization recommendations has been applied; analysis, recommendation and validation above are based on previous VM and related size. ";
export const ASPResourceCHangeFlagInfoTextSummaryOptimizing =
  "ASP resizing per optimization recommendations has been initiated;  analysis and recommendation above are based on previous ASP and related size. ";
export const ASPResourceCHangeFlagInfoTextSummaryOptimized =
  "ASP resizing per optimization recommendations has been applied; analysis and recommendation above are based on previous ASP and related size. ";
export const PerformDBAnalysisInfoText =
  "<p>For each selected DB, analyze historical data for several usage and health metrics using advanced machine learning techniques to determine thresholds and trends which then are used by optimization techniques to determine sizing recommendations for each optimization objective.</p>";
export const GenerateDBReportInfoText0 =
  "<p>Produce an overall report for all selected DBs with a summary table of recommendation benefits for each optimization objective as well as the ability to drill down into detail reports of each DB.</p>";
export const DBRersourceChangedFLagInfoTextAnalyzed =
  "The analysis and recommendation of this Database is no longer current as the Databse sizing has changed.";
export const DBResourceChngedFlagInfoTextSummaryAnalyzed =
  "DB sizing has changed post analysis and recommendation, reset and analyze to make analysis and recommendation current. ";
export const DBResourceCHangeFlagInfoTextSummaryOptimizing =
  "DB resizing per optimization recommendations has been initiated;  analysis and recommendation above are based on previous DB and related size. ";
export const DBResourceCHangeFlagInfoTextSummaryOptimized =
  "DB resizing per optimization recommendations has been applied; analysis and recommendation above are based on previous DB and related size. ";
export const VMsRightsizingBenefitsMsg =
  "Only VM and Disk costs included, VM is unreserved, disks are LRS, one month has 730 hrs";
export const ASPsRightsizingBenefitsMsg =
  "ASP is unreserved and one month has 730 hrs";
export const DBaasRightsizingBenefitsMsg =
  "DBaaS is unreserved and one month has 730 hrs";
